import type { CSSProperties } from 'react';

/** Each bat crosses the screen now and then: height, flight time, start delay, size, direction. */
const bats = [
  { top: '12%', duration: 22, delay: 2, size: 34, reverse: false },
  { top: '30%', duration: 28, delay: 11, size: 24, reverse: true },
  { top: '58%', duration: 25, delay: 6, size: 28, reverse: false },
  { top: '20%', duration: 34, delay: 19, size: 20, reverse: true },
  { top: '76%', duration: 30, delay: 15, size: 22, reverse: false },
];

/**
 * Bats flying across the app. Always mounted but hidden by CSS unless <html> has the `halloween`
 * class (see lib/theme.ts), so switching theme needs no React state here.
 */
export function HalloweenBats() {
  return (
    <div className="nx-bats" aria-hidden="true">
      {bats.map((bat, i) => (
        <div
          key={i}
          className={bat.reverse ? 'nx-bat nx-bat-reverse' : 'nx-bat'}
          style={
            {
              top: bat.top,
              animationDuration: `${bat.duration}s`,
              animationDelay: `${bat.delay}s`,
              '--nx-bat-size': `${bat.size}px`,
            } as CSSProperties
          }
        >
          <svg viewBox="0 0 64 32" className="nx-bat-body">
            <g className="nx-bat-wings" fill="currentColor">
              <path d="M32 14 C26 4 14 2 2 8 C8 10 10 14 9 18 C13 15 17 16 19 20 C22 16 27 16 32 20 Z" />
              <path d="M32 14 C38 4 50 2 62 8 C56 10 54 14 55 18 C51 15 47 16 45 20 C42 16 37 16 32 20 Z" />
            </g>
            <ellipse cx="32" cy="17" rx="4" ry="6" fill="currentColor" />
            <path d="M29 12 L30 8 L31.5 11 M34.5 11 L34 8 L35 12" fill="currentColor" />
          </svg>
        </div>
      ))}
    </div>
  );
}
